<script>
export default {
  name: "UserLoginView",
  created() {
    document.title = "Sign in";
  },
};
</script>

<template>
  <v-row>
    <v-col></v-col>
    <v-col cols="6">
      <v-card>
        <v-card-item>
          <v-card-title> Sign in to the platform </v-card-title>

          <v-divider></v-divider>

          <v-card-text>
            <LoginComponent />
          </v-card-text>
        </v-card-item>
      </v-card>
    </v-col>
    <v-col></v-col>
  </v-row>
</template>
